// Anita Week 1 / Day 2 — Cards, Sets and Value (U.S. Grade 3 math upgrade).
// URGENT: this is the day Anita does tomorrow. Math was previously Grade 1–2
// (4 × 3, 5 × 4) and has been replaced with Grade-3 two-step word problems,
// equal-groups for two different materials, "enough or not enough" comparison,
// simple fractions 1/2 and 1/4, and an error-finding logic task. The cards
// theme is preserved.
// SAFETY: paper simulations only — no real selling, no profit talk for the child.

const day2 = {
  id: 'day-2',
  studentId: 'anita',
  weekId: 'week-1',
  dayId: 'day-2',
  status: 'active',
  title: 'Карточки, наборы и ценность / Cards, Sets and Value',
  shortTitle: 'Наборы и ценность / Sets and Value',
  theme:
    'Когда вещи идут наборами, считать удобнее группами. После материалов остаётся «чистая ценность» набора. / When things come in sets, counting is easier in groups. After materials, a set has its "net value".',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro:
    'Нимни показывает Аните мастерскую карточек. Сегодня Анита считает карточки группами, проверяет, хватит ли материалов, и находит, сколько ценности остаётся у набора. / Nimny shows Anita the card workshop. Today Anita counts cards in groups, checks if materials are enough, and finds how much value a set has left.',
  goals: [
    'Считать карточки и ценность набора в два шага (× и +). / Count cards and set value in two steps (× and +).',
    'Понять, что после материалов остаётся «чистая ценность» набора. / Understand "net value" of a set after materials.',
    'Сравнивать «есть / нужно» и понимать, чего не хватает. / Compare "have / need" and find what is missing.',
    'Работать с простыми дробями 1/2 и 1/4 от числа. / Work with simple fractions 1/2 and 1/4.',
    'Найти ошибку в рассуждении Нимни и объяснить, почему она ошибка. / Find Nimny\'s error and explain it.'
  ],
  vocabulary: [
    { term: 'набор / set', definition: 'несколько одинаковых вещей вместе. / several same things together.' },
    { term: 'карточка / card', definition: 'маленький лист с рисунком или числом. / a small sheet with a picture or number.' },
    { term: 'лист / sheet', definition: 'бумажный лист, из которого делают карточки. / a sheet of paper for making cards.' },
    { term: 'наклейка / sticker', definition: 'клейкая картинка для украшения. / a sticky picture for decoration.' },
    { term: 'хватит / enough', definition: 'когда того, что есть, достаточно. / when what we have is enough.' },
    { term: 'осталось / remained', definition: 'сколько осталось после того, как часть взяли. / how much is left after part was taken.' }
  ],
  onlineTasks: [
    {
      id: 'reading-words',
      type: 'text',
      title: 'Слова дня / Words of the Day',
      prompt: 'Прочитай: набор, карточка, лист, наклейка, хватит, осталось.',
      ruPrimaryText: 'Прочитай по-русски: набор, карточка, лист, наклейка, хватит, осталось.',
      enHelpText: 'Read in Russian: set, card, sheet, sticker, enough, remained.',
      hint: 'Сначала русское чтение. Английский — только если трудно. / Russian first; English only if it is hard.',
      answer: 'Попытка чтения русских слов. / Attempted Russian reading.'
    },
    {
      id: 'reading-sentences',
      type: 'text',
      title: 'Маленькое чтение / Short Reading',
      prompt:
        'Прочитай по-русски:\n1. Анита делает карточки для игры.\n2. В каждом наборе одинаковое число карточек.\n3. Я считаю карточки группами.\n4. Я проверяю, хватит ли материалов.',
      ruPrimaryText:
        'Прочитай 4 короткие фразы про наборы карточек.',
      enHelpText:
        '1. Anita makes cards for a game.\n2. Every set has the same number of cards.\n3. I count cards in groups.\n4. I check if there are enough materials.',
      answer: 'Попытка чтения 4 русских фраз. / Attempted Russian reading.'
    },
    {
      id: 'math-1-cards-and-value',
      type: 'math',
      title: 'Math 1 — Сколько карточек и сколько нимов / Cards and Value',
      prompt:
        'Анита сделала 3 набора карточек.\nВ каждом наборе 4 карточки.\nКаждая карточка имеет игровую ценность 5 нимов.\n\n1. Сколько карточек всего?\n2. Сколько нимов стоит весь большой набор?\n\nЗапиши ответ через /: карточки / нимы. Например: 12 / 60.',
      ruPrimaryText:
        '3 набора × 4 карточки. Каждая карточка = 5 нимов. Сколько карточек и сколько нимов? Ответ через /: 12 / 60.',
      enHelpText:
        '3 sets of 4 cards each. Each card has a game value of 5 nims. First find the number of cards, then multiply by 5. Write the answer with a slash: cards / nims. Example: 12 / 60.',
      helper: 'Шаг 1: 3 × 4 карточки. Шаг 2: всего карточек × 5. Ответ через /: карточки / нимы. / Step 1 then step 2. Format as cards / nims.',
      answer: '12 / 60',
      unit: ''
    },
    {
      id: 'math-2-net-value',
      type: 'math',
      title: 'Math 2 — Остаток после материалов / Net Value After Materials',
      prompt:
        'У Аниты было 90 нимов.\nОна сделала карточки общей ценностью 60 нимов.\nНо материалы стоили 18 нимов.\nСколько нимов «чистой ценности» осталось у набора после материалов?',
      ruPrimaryText:
        'Ценность набора 60. Материалы 18. Чистая ценность = ?',
      enHelpText:
        'Set value 60. Materials cost 18. Subtract the material cost from the set value.',
      helper: 'Чистая ценность = ценность набора − стоимость материалов. / Net value = set value − material cost.',
      answer: '42',
      unit: 'нима чистой ценности / nims of net value'
    },
    {
      id: 'math-3-materials-for-sets',
      type: 'math',
      title: 'Math 3 — Материалы для 5 наборов / Materials for 5 Sets',
      prompt:
        'Для одного набора нужно:\n2 листа бумаги\n4 наклейки\n\nАнита делает 5 наборов.\nСколько листов бумаги и сколько наклеек ей нужно?\n\nЗапиши ответ через /: листы / наклейки. Например: 10 / 20.',
      ruPrimaryText:
        'Один набор: 2 листа + 4 наклейки. 5 наборов. Сколько листов и наклеек? Ответ через /: 10 / 20.',
      enHelpText:
        'One set needs 2 sheets and 4 stickers. Anita makes 5 sets. Multiply each material by 5. Write the answer with a slash: sheets / stickers. Example: 10 / 20.',
      helper: 'Считай каждый материал отдельно. Ответ через /: листы / наклейки. / Count each material separately. Format as sheets / stickers.',
      answer: '10 / 20',
      unit: ''
    },
    {
      id: 'math-4-have-vs-need',
      type: 'math',
      title: 'Math 4 — Хватит ли материалов? / Will the Materials Be Enough?',
      prompt:
        'У Аниты есть 14 листов бумаги и 14 наклеек.\nДля одного набора нужно 2 листа и 4 наклейки.\nОна хочет сделать 4 набора.\n\nХватит ли бумаги?\nХватит ли наклеек?\nЧего не хватает и сколько?\n\nЗапиши ответ через /: бумага / наклейки. Например: хватит / не хватит 2.',
      ruPrimaryText:
        'Есть: 14 листов и 14 наклеек. Нужно на 4 набора: 2 × 4 листа и 4 × 4 наклеек. Хватит ли? Ответ через /: бумага / наклейки.',
      enHelpText:
        'You have 14 sheets and 14 stickers. One set needs 2 sheets and 4 stickers. Anita wants 4 sets. Find what 4 sets need, then compare. Write the answer with a slash: paper / stickers. Example: enough / short 2.',
      helper: 'Сначала «нужно для 4 наборов», потом сравни с «есть». Ответ через /: бумага / наклейки. / First "need for 4 sets", then compare. Format as paper / stickers.',
      answer: 'хватит / не хватит 2',
      unit: ''
    },
    {
      id: 'math-5-half-and-quarter',
      type: 'math',
      title: 'Math 5 — Половина и четверть / Half and a Quarter',
      prompt:
        'Анита сделала 24 карточки.\nПоловину она оставила себе.\n1/4 всех карточек она подарила Нимни.\nОстальные карточки остались для игры.\n\nСколько карточек осталось для игры?',
      ruPrimaryText:
        '24 карточки. 1/2 себе, 1/4 Нимни. Остальное для игры. Сколько?',
      enHelpText:
        '24 cards total. Half kept for herself. 1/4 given to Nimny. Remaining go to the game. Find 1/2 and 1/4 of 24.',
      helper: '1/2 от 24 = 12. 1/4 от 24 = 6. Что осталось? / What remains?',
      answer: '6',
      unit: 'карточек для игры / cards for the game'
    },
    {
      id: 'logic-find-nimny-mistake',
      type: 'text',
      title: 'Логика — найди ошибку Нимни / Logic — Find Nimny\'s Mistake',
      prompt:
        'Нимни говорит: «Если в одном наборе 4 карточки, то в 3 наборах будет 7 карточек, потому что 4 + 3 = 7.»\nГде ошибка? Напиши 1–2 предложения и покажи правильный счёт.',
      ruPrimaryText:
        'Нимни ошиблась: «3 набора по 4 = 4 + 3 = 7». Объясни ошибку.',
      enHelpText:
        'Nimny says: "If one set has 4 cards, then 3 sets have 7 cards because 4 + 3 = 7." Where is the mistake? Explain in 1–2 sentences and show the correct calculation.',
      placeholder: 'Ошибка в том, что ... Правильно: 3 × 4 = ...',
      answer:
        'Правильный ответ: нужно 4 × 3, а не 4 + 3. В 3 наборах по 4 карточки = 12, а не 7. Принимается, если ребёнок объясняет, что наборы — это группы и нужно умножать.'
    },
    {
      id: 'spelling-set',
      type: 'text',
      title: 'Правописание / Spelling',
      prompt:
        'Напиши:\nнабор\nкарточка\nлист\nнаклейка\n\nВставь буквы:\nна_ор\nкарто_ка\nли_т\nнакле_ка',
      ruPrimaryText: 'Напиши слова и вставь пропущенные буквы.',
      enHelpText: 'Write the words and fill in the missing letters: набор, карточка, лист, наклейка.',
      answer: 'набор, карточка, лист, наклейка.'
    },
    {
      id: 'creative-my-set',
      type: 'text',
      title: 'Мой маленький набор / My Small Set',
      prompt:
        'Нарисуй свой маленький набор из 3–4 карточек.\nПодпиши 2 предложения по-русски:\n«Я сделал(а) набор.»\n«В нём ___ карточки.»',
      ruPrimaryText: 'Нарисуй набор из 3–4 карточек и подпиши 2 фразы.',
      enHelpText: 'Draw your small set of 3–4 cards and write 2 Russian sentences.',
      answer:
        'Open-ended. Принимается, если есть рисунок 3–4 карточек и две короткие русские фразы.'
    },
    {
      id: 'speech-explain-groups',
      type: 'text',
      title: 'Объясни родителю / Explain to Parent',
      prompt: 'Скажи по-русски: почему наборы удобно считать группами?',
      ruPrimaryText: 'Скажи по-русски: «Наборы удобно считать группами, потому что …».',
      enHelpText: 'Say in Russian: "It is easy to count sets in groups because …".',
      answer:
        'Принимаются ответы вроде «Потому что в каждом наборе одинаковое число.» «Так быстрее, чем считать по одной.»'
    }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова дня.',
    '2. Реши 5 math задач с шагами в тетради (Math 1–5).',
    '3. Найди ошибку Нимни и покажи правильный счёт.',
    '4. Напиши 4 слова на правописание.',
    '5. Нарисуй свой маленький набор и подпиши 2 фразы.',
    '6. Скажи родителю по-русски: «Наборы удобно считать группами, потому что …».'
  ],
  printWorksheet: {
    title: 'Карточки, наборы и ценность / Cards, Sets and Value',
    subtitle: 'Неделя 1 · День 2 / Week 1 · Day 2',
    pages: [
      {
        title: 'Маршрут дня · Слова · Чтение / Route, Words and Reading',
        blocks: [
          { type: 'text', text: 'Миссия: Анита учится считать наборы группами и проверять, хватит ли материалов. / Mission: Anita counts sets in groups and checks if materials are enough.' },
          { type: 'list', items: [
            'Слова дня: набор, карточка, лист, наклейка, хватит, осталось. / Words of the day.',
            'Маленькое чтение — 4 короткие фразы по-русски про наборы (см. экран). / Short Russian reading.',
            'English help мелким шрифтом. / English help in small print.'
          ] }
        ]
      },
      {
        title: 'Математика наборов / Set Math',
        blocks: [
          { type: 'text', text: 'Показывай шаги. Используй × для групп. / Show steps. Use × for groups.' },
          { type: 'list', items: [
            'Math 1. 3 × 4 карточки = ___. Каждая × 5 нимов = ___ нимов. / Cards and value.',
            'Math 2. Ценность 60 − материалы 18 = ___ нимов чистой ценности. / Net value.',
            'Math 3. 2 × 5 = ___ листов; 4 × 5 = ___ наклеек для 5 наборов. / Materials for 5 sets.',
            'Math 4. На 4 набора нужно 2 × 4 = ___ листов и 4 × 4 = ___ наклеек. Есть 14 и 14. Хватит ли? Чего не хватает? / Have vs need.',
            'Math 5. 1/2 от 24 = ___; 1/4 от 24 = ___; для игры = 24 − ___ − ___ = ___ карточек. / Half and a quarter.'
          ] }
        ]
      },
      {
        title: 'Логика, правописание, рисунок / Logic, Spelling, Drawing',
        blocks: [
          { type: 'list', items: [
            'Логика: Нимни сказала «3 набора × 4 = 4 + 3 = 7». Где ошибка? Правильный счёт: 3 × 4 = ___. / Find Nimny\'s mistake.',
            'Правописание: напиши набор, карточка, лист, наклейка. Вставь буквы: на_ор, карто_ка, ли_т, накле_ка. / Spelling.',
            'Нарисуй маленький набор (3–4 карточки) и подпиши: «Я сделал(а) набор. В нём ___ карточки.» / Draw a small set with 2 Russian sentences.',
            'Скажи родителю: «Наборы удобно считать группами, потому что …». / Say in Russian to a parent.',
            'Parent Check: × для групп, сравнение «есть/нужно», 1/2 и 1/4. / Parent Check.',
            'Notebook Mode fallback. / Notebook Mode fallback.'
          ] }
        ]
      }
    ]
  },
  parentGuide: {
    goal:
      'Анита считает наборы группами, понимает «чистую ценность» после материалов, сравнивает «есть/нужно» и работает с простыми дробями 1/2 и 1/4.',
    mathGoal:
      'U.S. Grade 3: × как первый шаг внутри двухшаговой задачи, сравнение «есть/нужно» для двух материалов, простые дроби 1/2 и 1/4 от числа, выявление и объяснение ошибки.',
    russianGoal:
      'Прочитать слова: набор, карточка, лист, наклейка, хватит, осталось.',
    readingWritingGoal:
      'Прочитать 4 короткие фразы, написать 4 слова, подписать рисунок набора двумя фразами.',
    practicalGoal:
      'Найти ошибку Нимни и объяснить, почему наборы считают умножением, а не сложением.',
    whatThisLessonTeaches:
      'Анита переходит от простого × к двухшаговым задачам: сначала считаем группами, потом находим ценность, остаток или «хватит ли материалов».',
    keyMessage:
      'Когда вещи идут наборами, считать удобнее группами. После материалов набор имеет «чистую ценность» — это сколько ценности у него осталось.',
    howToExplain:
      'Возьмите 14 листов бумаги и 14 фишек/наклеек. Покажите, что для 4 наборов нужно 8 листов и 16 наклеек — и одного материала не хватит.',
    exampleDialogue:
      'Parent: Сколько листов нужно на 4 набора?\nChild: 2 × 4 = 8.\nParent: А наклеек?\nChild: 4 × 4 = 16.\nParent: У тебя 14 и 14. Чего не хватает?\nChild: Наклеек, нужно ещё 2.',
    readingSupport:
      'Родитель помогает с длинными словами «карточка», «наклейка». Английский — только для понимания смысла.',
    russianSpeechGoal:
      'Анита говорит по-русски: «Наборы удобно считать группами, потому что в каждом наборе одинаковое число.»',
    mathAnswerKey:
      'Math 1: 3 × 4 = 12 карточек; 12 × 5 = 60 нимов.\nMath 2: 60 − 18 = 42 нима чистой ценности.\nMath 3: 2 × 5 = 10 листов; 4 × 5 = 20 наклеек.\nMath 4: нужно 8 листов и 16 наклеек; есть 14 и 14; бумаги хватит, наклеек не хватает 2.\nMath 5: 1/2 от 24 = 12; 1/4 от 24 = 6; для игры 24 − 12 − 6 = 6 карточек.',
    spellingAnswerKey: 'набор\nкарточка\nлист\nнаклейка',
    answerKey: [
      { taskId: 'reading-words', answer: 'Answer: попытка чтения 6 русских слов.\nSolution: Анита читает по очереди; родитель подсказывает только по слогам.\nParent note: Засчитывать честную попытку.' },
      { taskId: 'reading-sentences', answer: 'Answer: попытка чтения 4 русских фраз про наборы.\nSolution: Каждая фраза — отдельно.\nParent note: Главное — понимание смысла.' },
      { taskId: 'math-1-cards-and-value', answer: 'Answer: 12 карточек, 60 нимов.\nSolution: 3 × 4 = 12 карточек; 12 × 5 = 60 нимов.\nParent note: Это двухшаговая задача; не давайте сразу 12 × 5, чтобы ребёнок сам нашёл первый шаг.' },
      { taskId: 'math-2-net-value', answer: 'Answer: 42 нима чистой ценности.\nSolution: 60 − 18 = 42.\nParent note: Не используйте слова «прибыль» / «profit». Говорите «чистая ценность» или «ценность после материалов».' },
      { taskId: 'math-3-materials-for-sets', answer: 'Answer: 10 листов и 20 наклеек.\nSolution: 2 × 5 = 10; 4 × 5 = 20.\nParent note: Здесь две одновременные величины — пусть ребёнок посчитает каждую отдельно.' },
      { taskId: 'math-4-have-vs-need', answer: 'Answer: бумаги хватит, наклеек не хватит — нужно ещё 2.\nSolution: Нужно 2 × 4 = 8 листов и 4 × 4 = 16 наклеек. Есть 14 и 14. 14 ≥ 8 (хватит); 14 < 16 (не хватит, нужно ещё 16 − 14 = 2).\nParent note: Это задача на сравнение «есть/нужно» с двумя материалами.' },
      { taskId: 'math-5-half-and-quarter', answer: 'Answer: 6 карточек для игры.\nSolution: 1/2 от 24 = 12; 1/4 от 24 = 6; 24 − 12 − 6 = 6.\nParent note: Это Grade-3 fraction reasoning на простых дробях.' },
      { taskId: 'logic-find-nimny-mistake', answer: 'Answer: Ошибка в том, что Нимни сложила вместо умножения. Правильно: 3 × 4 = 12 карточек.\nSolution: Наборы — это группы по 4, и их 3. 4 + 3 = 7 — это просто сумма двух чисел, а не «3 набора по 4».\nParent note: Принимается любое объяснение, что наборы умножают, а не складывают.' },
      { taskId: 'spelling-set', answer: 'Answer: набор, карточка, лист, наклейка.\nSolution: Вставленные буквы: б, ч, с, й.\nParent note: Мягкие ошибки допустимы; главное — узнаваемые слова.' },
      { taskId: 'creative-my-set', answer: 'Answer: рисунок 3–4 карточек + 2 русские фразы.\nSolution: Open-ended.\nParent note: Принимается даже минимальный текст, если есть рисунок и числа карточек.' },
      { taskId: 'speech-explain-groups', answer: 'Answer: одна осмысленная русская фраза про группы.\nSolution: «Так быстрее.» «В каждом наборе одинаково.»\nParent note: Главное — мысль, не идеальная грамматика.' }
    ],
    check: [
      'Анита прочитала русские слова и 4 фразы.',
      'Анита решила Math 1–5 с показом шагов.',
      'Анита нашла ошибку Нимни.',
      'Анита написала 4 слова и подписала набор двумя фразами.',
      'Анита объяснила, почему наборы считают группами.'
    ],
    spellingCheck:
      'Проверить буквы в словах набор, карточка, лист, наклейка.',
    readingCheck:
      'Засчитывать попытку чтения. Слово «наклейка» трудное — можно помочь.',
    practicalCheck:
      'Анита понимает, что «3 набора по 4» — это 3 × 4, не 3 + 4.',
    drawingCriteria:
      'Есть набор из 3–4 карточек и 2 русские фразы с правильным числом карточек в подписи.',
    commonMistakes: [
      '«3 набора по 4 = 4 + 3.» Правильно: 3 × 4 = 12.',
      '«Чистая ценность = ценность набора.» Правильно: ценность − материалы.',
      '«Хватит, если есть хоть что-то.» Правильно: нужно сравнить «есть» и «нужно для всех наборов».'
    ],
    discussionPrompts: [
      'Почему наборы считать группами быстрее?',
      'Что случится, если материала не хватит?',
      'Что такое «чистая ценность»?'
    ],
    ifEasy:
      'Анита делает 6 наборов по 4 карточки. Каждая 5 нимов. Сколько всего нимов? (Ответ: 6 × 4 = 24 карточки; 24 × 5 = 120.) Хватит ли 12 листов и 25 наклеек? (Нужно 12 и 24. Хватит обоих, но 1 наклейка остаётся.)',
    ifDifficult:
      'Оставьте только Math 1 и Math 4. Math 4 разберите вместе на бумаге, считая по группам.',
    rewardGuidance:
      'Базовая награда — 3 нима. Бонус за самостоятельное двухшаговое решение или хорошее объяснение ошибки Нимни.',
    parentOnlyNotes:
      'Не превращайте урок в реальную продажу. Не используйте слова «прибыль», «выручка», «оплата». Говорите «ценность» и «чистая ценность».',
    tokenReward:
      'Нимы — это призовые токены курса, а не оплата.'
  },
  reward: {
    unit: 'nim',
    unitName: 'ним',
    base: 3,
    max: 5,
    label: 'Награда за миссию',
    display: '3 нима',
    bonuses: [
      { id: 'two-step-math', label: 'Бонус за самостоятельное двухшаговое решение', amount: 1 },
      { id: 'found-nimny-mistake', label: 'Бонус за объяснение ошибки Нимни', amount: 1 }
    ]
  },
  completionRequirements: {
    requiredTaskIds: [
      'reading-words',
      'reading-sentences',
      'math-1-cards-and-value',
      'math-2-net-value',
      'math-3-materials-for-sets',
      'math-4-have-vs-need',
      'math-5-half-and-quarter',
      'logic-find-nimny-mistake',
      'spelling-set',
      'creative-my-set',
      'speech-explain-groups'
    ],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-1-day-3'
};

export default day2;
